import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../Context/UserContext";
import Header from "../../Components/Header/Header";
import "./ProfileEdit.css";
import ProfileCover from "../../assets/images/ProfileCover.svg";
import ProfileEditIcon from "../../assets/images/profile-edit.svg";
import Select from "react-select";
import { callApi } from "../../utils/apiService";
import { videoCreatorEndPoint } from "../../Constants/constants";
import { toast } from "react-hot-toast";
import { showToast } from "../../utils/toastUtils";

const ProfileEdit = () => {
  const navigate = useNavigate();
  const { user: initialUser, updateUser, languages } = useUser();

  const [formData, setFormData] = useState({
    name: initialUser?.fullName || "",
    email: initialUser?.email || "",
    languages: initialUser?.languages?.map((lang) => lang._id) || [],
    mobile: initialUser?.mobileNumber || "",
    youtubeLink: initialUser?.youtube_link || "",
    instagramLink: initialUser?.instagram_link || "",
    imagePreview: initialUser?.profileUrl || "",
  });

  const [errors, setErrors] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(
    initialUser?.profileUrl || "",
  );

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    setSelectedImage(file);
    setImagePreview(URL.createObjectURL(file));
  };

  useEffect(() => {
    if (initialUser) {
      setFormData({
        name: initialUser?.fullName || "",
        email: initialUser?.email || "",
        languages: initialUser?.languages?.map((lang) => lang.id) || [],
        mobile: initialUser?.mobileNumber || "",
        youtubeLink: initialUser?.youtube_link || "",
        instagramLink: initialUser?.instagram_link || "",
        imagePreview: initialUser?.profileUrl || "",
      });
      setImagePreview(initialUser?.profileUrl);
    }
  }, [initialUser]);
  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Full Name is required";
    if (!formData.email.trim()) newErrors.email = "Email Address is required";
    if (!formData.mobile.trim()) newErrors.mobile = "Mobile Number is required";
    if (!formData.languages?.length)
      newErrors.languages = "Languages Known is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSave = async () => {
    if (!validateForm()) return;

    try {
      const payload = {
        fullName: formData.name,
        languages: formData.languages,
      };

      if (formData.youtubeLink?.trim()) {
        payload.youtube_link = formData.youtubeLink;
      }

      if (formData.instagramLink?.trim()) {
        payload.instagram_link = formData.instagramLink;
      }

      // Add image details
      if (selectedImage) {
        console.log("Selected Image:", selectedImage);
        payload.profileImageName = selectedImage.name.replace(/\.[^/.]+$/, "");
        payload.profileImageSize = selectedImage.size;
        payload.profileImageType = selectedImage.type;
      }

      const response = await callApi(
        `${videoCreatorEndPoint}auth/update-profile`,
        "PATCH",
        payload,
      );

      // Upload image to S3 if URL received
      if (selectedImage && response?.data?.profileImageUploadUrl) {
        await fetch(response.data.profileImageUploadUrl, {
          method: "PUT",
          headers: {
            "Content-Type": selectedImage.type,
          },
          body: selectedImage,
        });
        setImagePreview(response?.data?.creator?.profileUrl);
      }

      updateUser({
        ...response?.data?.creator,
        youtube_link: response?.data?.creator?.youtube_link,
        instagram_link: response?.data?.creator?.instagram_link,
        profileUrl: response?.data?.creator?.profileUrl,
      });

      showToast(
        "success",
        response?.alert || "Profile updated successfully",
        100,
      );

      navigate(-1);
    } catch (error) {
      showToast("error", error?.message || "Failed to update profile");
    }
  };

  const languageOptions = languages.map((lang) => ({
    value: lang.id,
    label: lang.dataName,
  }));

  const selectedLanguages = languageOptions.filter((option) =>
    formData.languages.includes(option.value),
  );

  const handleLanguageChange = (selectedOptions) => {
    const selectedIds = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];

    setFormData((prev) => ({
      ...prev,
      languages: selectedIds,
    }));

    setErrors((prev) => ({
      ...prev,
      languages: "",
    }));
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="p-8 max-w-7xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <div className="h-48 w-full overflow-hidden">
            <img
              src={ProfileCover}
              alt="Profile Cover"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Content Container */}
          <div className="px-8 py-6 mt-10">
            <div className="flex items-center justify-between mb-10">
              <div className="flex items-center gap-4">
                <div className="story-avatar-wrapper">
                  {imagePreview ? (
                    <img
                      src={imagePreview}
                      alt="Profile"
                      className="w-full h-full rounded-full object-cover profile-img-size"
                    />
                  ) : (
                    <div className="rounded-full flex items-center justify-center text-white text-3xl font-bold profile-bg-color">
                      {initialUser?.fullName?.charAt(0) || ""}
                    </div>
                  )}
                  <input
                    type="file"
                    id="profileImageInput"
                    style={{ display: "none" }}
                    onChange={handleImageChange}
                    accept=".jpg,.jpeg,.png"
                  />

                  <img
                    src={ProfileEditIcon}
                    className="profile-story-plus"
                    onClick={() =>
                      document.getElementById("profileImageInput").click()
                    }
                  />
                  {/* <img src={ProfileEditIcon} className="profile-story-plus" /> */}
                </div>

                <div>
                  <p className="f-fam-name-poppins text-[20px] font-medium text-[#000000]">
                    {initialUser?.fullName || "User"}
                  </p>
                  <p className="f-fam-name-poppins text-[16px] font-normal text-[#000000]">
                    @{initialUser?.userName || "username"}
                  </p>
                </div>
              </div>
              <button
                onClick={handleSave}
                style={{ backgroundColor: "#7818D2" }}
                className="hover:opacity-90 text-[#FFFFFF] px-6 py-3 rounded-lg transition-opacity f-fam-name-poppins text-[16px] font-normal"
              >
                Save Changes
              </button>
            </div>

            {/* Basic Details Form */}
            <div className="basic-details-container">
              <h2 className="f-fam-name-inter text-[22px] font-bold text-[#140D1C] mb-6">
                Basic Details
              </h2>

              <div className="grid grid-cols-2 gap-8">
                {/* Left Column */}
                <div className="space-y-6">
                  {/* Full Name */}
                  <div>
                    <label className="block f-fam-name-inter text-[16px] font-medium text-[#140D1C] mb-2">
                      Full Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder="Enter your full name"
                      className={`bg-and-border w-full px-4 py-3 border-2 rounded-lg focus:outline-none transition f-fam-name-inter text-[14px] 
                        font-normal text-[#140D1C] ${
                          errors.name
                            ? "red-border-error"
                            : "border-[1px] border-[rgba(219,207,232,1)] focus:border-purple-500"
                        }`}
                    />
                    {errors.name && (
                      <p className="text-red-500 text-sm mt-1">{errors.name}</p>
                    )}
                  </div>

                  {/* Mobile Number */}
                  <div>
                    <label className="block f-fam-name-inter text-[16px] font-medium text-[#140D1C]  mb-2">
                      Mobile Number <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="tel"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleInputChange}
                      disabled
                      placeholder="Enter your Mobile Number"
                      className={`bg-and-border w-full px-4 py-3 border-2 rounded-lg focus:outline-none transition f-fam-name-inter text-[14px] 
                        font-normal text-[#140D1C] ${
                          errors.mobile
                            ? "red-border-error"
                            : "border-[1px] border-[rgba(219,207,232,1)] focus:border-purple-500"
                        }`}
                    />
                    {errors.mobile && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.mobile}
                      </p>
                    )}
                  </div>

                  {/* Email Address */}
                  <div>
                    <label className="block f-fam-name-inter text-[16px] font-medium text-[#140D1C] mb-2">
                      Email Address <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      disabled
                      placeholder="Enter your email address"
                      className={`bg-and-border w-full px-4 py-3 border-2 rounded-lg focus:outline-none transition f-fam-name-inter text-[14px] 
                        font-normal text-[#140D1C] ${
                          errors.email
                            ? "red-border-error"
                            : "border-[1px] border-[rgba(219,207,232,1)] focus:border-purple-500"
                        }`}
                    />
                    {errors.email && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.email}
                      </p>
                    )}
                  </div>
                </div>

                {/* Right Column */}
                <div className="space-y-6">
                  {/* Languages Known */}
                  <div>
                    <label className="block f-fam-name-inter text-[16px] font-medium text-[#140D1C] mb-2">
                      Languages Known <span className="text-red-500">*</span>
                    </label>
                    <Select
                      isMulti
                      menuPlacement="auto"
                      menuPosition="fixed"
                      options={languageOptions}
                      value={selectedLanguages}
                      onChange={handleLanguageChange}
                      placeholder="Select Languages"
                      classNamePrefix="profile-select"
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          minHeight: "48px",
                          border: errors.languages
                            ? "1px solid rgba(239, 68, 68, 1)"
                            : "1px solid rgba(219, 207, 232, 1)",
                          boxShadow: "none",
                          borderRadius: "0.5rem",
                          backgroundColor: "#FAF7FC",
                        }),
                      }}
                    />
                    {errors.languages && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.languages}
                      </p>
                    )}
                  </div>

                  {/* YouTube Link */}
                  <div>
                    <label className="block f-fam-name-inter text-[16px] font-medium text-[#140D1C] mb-2">
                      YouTube Link
                    </label>
                    <input
                      type="url"
                      name="youtubeLink"
                      value={formData.youtubeLink}
                      onChange={handleInputChange}
                      placeholder="Enter your social media link"
                      className={`bg-and-border w-full px-4 py-3 border-2 rounded-lg focus:outline-none transition f-fam-name-inter text-[14px] 
                        font-normal text-[#140D1C] ${
                          errors.youtubeLink
                            ? "border-red-500 focus:border-red-600"
                            : "border-[1px] border-[rgba(219,207,232,1)] focus:border-purple-500"
                        }`}
                    />
                  </div>

                  {/* Instagram Link */}
                  <div>
                    <label className="block f-fam-name-inter text-[16px] font-medium text-[#140D1C] mb-2">
                      Instagram Link
                    </label>
                    <input
                      type="url"
                      name="instagramLink"
                      value={formData.instagramLink}
                      onChange={handleInputChange}
                      placeholder="Enter your social media link"
                      className={`bg-and-border w-full px-4 py-3 border-2 rounded-lg focus:outline-none transition f-fam-name-inter text-[14px] 
                        font-normal text-[#140D1C] ${
                          errors.instagramLink
                            ? "border-red-500 focus:border-red-600"
                            : "border-[1px] border-[rgba(219,207,232,1)] focus:border-purple-500"
                        }`}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileEdit;
